export const GenericTabs = () => null;
